export default "__VITE_ASSET__Ci2K5I5S__"